import React, { useContext } from 'react';
import {
  DrawerBody,
  Skeleton,
  SkeletonBlock,
  SkeletonContent,
  SkeletonLine
} from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AddToContext } from '../../AddToContext';

export const AddToLoading = () => {
  const { customer } = useContext(ExperienceContext);
  const isB2B = customer?.type === 'b2b';

  const { defaultOpen } = useContext(AddToContext);
  const shouldShowAddMaterialsPlaceholder = isB2B && defaultOpen;

  if (shouldShowAddMaterialsPlaceholder) {
    return (
      <Skeleton grow disablePadding="y" orientation="vertical" data-testid="add-materials-skeleton">
        <SkeletonContent data-testid="add-materials-skeleton-content">
          <SkeletonBlock height={8} data-testid="add-materials-skeleton-block" />
          <SkeletonLine variant="heading" data-testid="add-materials-skeleton-line" />
        </SkeletonContent>
      </Skeleton>
    );
  }

  return (
    <>
      <DrawerBody>
        <Skeleton disablePadding="y" orientation="horizontal">
          <SkeletonBlock />
          <SkeletonLine />
        </Skeleton>
      </DrawerBody>
    </>
  );
};
